import { z } from 'zod';

import { ReportableEventId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const DeleteReportableEventEvent = BaseLoanEvent.extend({
  type: z.literal('deleteReportableEvent'),
  reportableEventId: zodBrandedUuid<ReportableEventId>(),
});
export type DeleteReportableEventEvent = z.infer<typeof DeleteReportableEventEvent>;
